import React from 'react';

/* ── Feature row icons ─────────────────────────────────────────── */
const IconDevices = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="13" height="10" rx="1.5" />
    <rect x="16" y="8" width="5" height="11" rx="1" />
    <line x1="6" y1="19" x2="13" y2="19" />
    <line x1="9.5" y1="15" x2="9.5" y2="19" />
  </svg>
);
const IconBilingual = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 5h9v9h-4l-3 3v-3H4z" />
    <path d="M11 12h9v6h-3l-2 2v-2h-4z" />
  </svg>
);
const IconBadge = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="10" r="6" />
    <polyline points="9 14 7.5 21 12 18.5 16.5 21 15 14" />
    <polyline points="9.5 10 11 11.5 14 8.5" />
  </svg>
);
const IconHeart = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-7-4.35-9.33-9.06C1.05 8.46 3.36 5 7 5c2.04 0 3.32 1.02 5 3 1.68-1.98 2.96-3 5-3 3.64 0 5.95 3.46 4.33 6.94C19 16.65 12 21 12 21z" />
  </svg>
);

const HIGHLIGHTS = [
  { Icon: IconDevices,   title: 'Available on',     sub: 'all your devices' },
  { Icon: IconBilingual, title: 'Read & listen in', sub: 'English & Arabic' },
  { Icon: IconBadge,     title: 'Quizzes, badges',  sub: '& reading progress' },
  { Icon: IconHeart,     title: 'Save favourites',  sub: '& build playlists' },
];

export default function WhatIsDeenLit() {
  return (
    <section className="what-is-deenlit" aria-label="What is DeenLit">
      <div className="wid-card">
        <div className="wid-art-left">
          <img
            src="/images/what-is/library-medallion.png"
            alt="Open book under a starry night sky"
            loading="lazy"
          />
        </div>

        <div className="wid-body">
          <h2 className="wid-title">What is DeenLit?</h2>
          <p className="wid-text">
            DeenLit is a digital Islamic library for children and teens, bringing
            together stories, poems, non-fiction, seerah, Qur&rsquo;anic stories,
            Muslim history, and more in one safe and engaging reading space.
            Whether at home, at school, or on the go, children can read across
            devices, listen in English and Arabic, take quizzes, save favourites,
            build playlists, and grow their love of reading one book at a time.
          </p>

          <ul className="wid-highlights" aria-label="What you get">
            {HIGHLIGHTS.map(({ Icon, title, sub }) => (
              <li key={title} className="wid-highlight">
                <span className="wid-highlight-icon"><Icon /></span>
                <div className="wid-highlight-text">
                  <strong>{title}</strong>
                  <span>{sub}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="wid-art-right">
          <img
            src="/images/what-is/devices.png"
            alt="DeenLit library shown on tablet and phone"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
